import { render } from "./CustomSelect.vue?vue&type=template&id=1fe66c50&scoped=true"
const script = {}

import "./CustomSelect.vue?vue&type=style&index=0&id=1fe66c50&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fe66c50"]])

export default __exports__